<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceIndex) in moduleData.hubSlices"
      :key="sliceIndex"
      :slice="slice"
      :categories="moduleData.allCategories"
    />
    <ArticlesList
      v-for="category in moduleData.allCategories"
      :key="category.categoryId"
      :category="category"
    />
  </div>
</template>

<script>
import { Hero } from '@@/shared-slices'

import { Categories, News, ArticlesList } from './components'

export default {
  name: 'AdvicesHubModule',

  components: {
    Hero,
    Categories,
    News,
    ArticlesList,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },
  },
}
</script>
